'use client';
import { FC } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const GCapcha: FC<{
    recaptchaRef: React.RefObject<ReCAPTCHA>;
    onChange?: (token?: string) => void;
}> = ({ recaptchaRef, onChange }) => {
    const onCaptchaChange = (token: string | null) => {
        // Set the captcha token when the user completes the reCAPTCHA
        if (token) {
            onChange?.(token);
        }
    };

    return (
        <div>
            <ReCAPTCHA
                size="normal"
                sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ?? ''}
                onChange={onCaptchaChange}
                ref={recaptchaRef}
            />
        </div>
    );
};

export default GCapcha;
